/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';

const InterviewContent = ({content, getRaw, addLinks, navigate}) => { 
    return (
        content.InterviewQuestions.map((item, itemIndex) =>
            <p key={itemIndex} style={{paddingBottom: '10px'}}>
                <span className="question" dangerouslySetInnerHTML={getRaw(item.Question)} />    
                {
                    item.Responses.map((response, responseIndex) => 
                        <React.Fragment key={responseIndex}>
                            {responseIndex > 0 ? <br /> : null}
                            <span className="respondent">{response.Respondent}</span>
                            {
                                response.Links && response.Links.length ?
                                    <span onClick={navigate} dangerouslySetInnerHTML={getRaw(' - ' + addLinks(response.Text, response.Links))} />
                                :
                                    <span dangerouslySetInnerHTML={getRaw(' - ' + response.Text)} />
                            }
                        </React.Fragment>
                    )
                }
            </p>
        )
    );
};

InterviewContent.propTypes = {
    content: PropTypes.object,
    getRaw: PropTypes.func.isRequired
};

export default InterviewContent;